import hexToRgba from 'hex-to-rgba'

const colors = require('./colors')

export { colors, hexToRgba }
